import React, { useState, useEffect } from 'react';

const UserProfile = ({ userName, userEmail, onUpdateProfile, onBack, isDarkMode, userRole, userPlan }) => {
  const [name, setName] = useState(userName);
  const [email, setEmail] = useState(userEmail);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [planDetails, setPlanDetails] = useState(null);

  const API_BASE_URL = 'https://holmio.net/app/api.php';

  useEffect(() => {
    setName(userName);
    setEmail(userEmail);
  }, [userName, userEmail]);

  useEffect(() => {
    const fetchPlanDetails = async () => {
      if (userPlan) {
        try {
          const response = await fetch(`${API_BASE_URL}/plans?id=${userPlan}`);
          const data = await response.json();
          if (data.status === 'success' && data.data.length > 0) {
            setPlanDetails(data.data[0]);
          } else {
            setPlanDetails(null);
          }
        } catch (error) {
          console.error('Error al cargar detalles del plan:', error);
          setPlanDetails(null);
        }
      }
    };
    fetchPlanDetails();
  }, [userPlan]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password && password !== confirmPassword) {
      alert('Las contraseñas no coinciden.');
      return;
    }
    onUpdateProfile(name, email, password);
    setPassword('');
    setConfirmPassword('');
  };

  const mainBgClass = isDarkMode ? 'bg-gray-800' : 'bg-white';
  const textColorClass = isDarkMode ? 'text-gray-100' : 'text-gray-800';
  const inputBgClass = isDarkMode ? 'bg-gray-700 text-white border-gray-600' : 'bg-gray-50 text-gray-900 border-gray-300';
  const buttonClass = isDarkMode ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-blue-500 hover:bg-blue-600 text-white';
  const backButtonClass = isDarkMode ? 'bg-gray-600 hover:bg-gray-700 text-white' : 'bg-gray-400 hover:bg-gray-500 text-white';
  const planDetailsBgClass = isDarkMode ? 'bg-gray-900' : 'bg-gray-100';
  const planDetailsTextColorClass = isDarkMode ? 'text-gray-300' : 'text-gray-700';
  const planDetailsTitleColorClass = isDarkMode ? 'text-white' : 'text-gray-800';

  return (
    <div className={`flex-1 p-6 rounded-2xl shadow-xl m-4 ${mainBgClass} ${textColorClass} transition-colors duration-300`}>
      <h2 className="text-3xl font-bold mb-6 text-center">Perfil de Usuario</h2>

      <form onSubmit={handleSubmit} className="space-y-6 max-w-md mx-auto p-6 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
        <div>
          <label htmlFor="name" className="block text-sm font-medium mb-1">Nombre de Usuario</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={`w-full px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${inputBgClass}`}
            required
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium mb-1">Correo Electrónico</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={`w-full px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${inputBgClass}`}
            required
          />
        </div>
        <div>
          <label htmlFor="password" className="block text-sm font-medium mb-1">Nueva Contraseña (opcional)</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`w-full px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${inputBgClass}`}
            placeholder="Deja en blanco para no cambiar"
          />
        </div>
        <div>
          <label htmlFor="confirmPassword" className="block text-sm font-medium mb-1">Confirmar Nueva Contraseña</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={`w-full px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${inputBgClass}`}
          />
        </div>
        <button
          type="submit"
          className={`w-full py-3 rounded-xl font-semibold transition-colors duration-300 ${buttonClass} shadow-md hover:shadow-lg`}
        >
          Actualizar Perfil
        </button>
      </form>

      <div className={`mt-8 max-w-md mx-auto p-6 rounded-xl shadow-md ${planDetailsBgClass} border border-gray-200 dark:border-gray-700`}>
        <h3 className={`text-xl font-bold mb-4 text-center ${planDetailsTitleColorClass}`}>Detalles del Plan</h3>
        {planDetails ? (
          <div className="space-y-2 text-sm">
            <p><span className="font-semibold">Plan Actual:</span> {planDetails.name}</p>
            <p><span className="font-semibold">Descripción:</span> {planDetails.description}</p>
            <p><span className="font-semibold">Límite de Dispositivos:</span> {planDetails.device_limit === -1 ? 'Ilimitado' : planDetails.device_limit}</p>
            <p><span className="font-semibold">Control Remoto:</span> {planDetails.remote_control ? 'Sí' : 'No'}</p>
            <p><span className="font-semibold">Historial de Datos:</span> {planDetails.history_days === -1 ? 'Ilimitado' : `${planDetails.history_days} días`}</p>
            <p className="text-lg font-bold mt-4">
              <span className="font-semibold">Precio:</span> US${parseFloat(planDetails.price).toFixed(2)} / {planDetails.billing_period}
            </p>
          </div>
        ) : (
          <p className="text-center text-sm">Cargando detalles del plan...</p>
        )}
      </div>

      <div className="mt-8 text-center">
        <button
          onClick={onBack}
          className={`px-6 py-3 rounded-xl font-semibold transition-colors duration-300 ${backButtonClass} shadow-md hover:shadow-lg`}
        >
          Volver al Dashboard
        </button>
      </div>
    </div>
  );
};

export default UserProfile;

// DONE